import {
  Box,
  Typography,
  TextField,
  Button,
  FormControlLabel,
  Checkbox,
  Alert,
} from "@mui/material";
import { useState } from "react";
import factory from "../assets/c1.jpeg";
import { toast } from "react-toastify";

export default function QuickContact() {
  const contactImage = factory;

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    company: "",
    industry: "",
    message: "",
    consent: false,
  });

  const [loading, setLoading] = useState(false);
  const [responseMsg, setResponseMsg] = useState(null);

  // HANDLE INPUT CHANGE
  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === "checkbox" ? checked : value,
    });
  };

  // SUBMIT FUNCTION
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setResponseMsg(null);

    const data = new FormData();
    data.append("access_key", "de439868-536f-48aa-8379-c6d5b7602433");
    data.append("subject", `New Quick Contact from ${formData.name}`);
    data.append("name", formData.name);
    data.append("email", formData.email);
    data.append("phone", formData.phone);
    data.append("company", formData.company);
    data.append("industry", formData.industry);
    data.append("message", formData.message);

    const response = await fetch("https://api.web3forms.com/submit", {
      method: "POST",
      body: data,
    });

    const result = await response.json();
    setLoading(false);

    if (result.success) {
      toast.success("Message sent successfully!");
      setFormData({
        name: "",
        email: "",
        phone: "",
        company: "",
        industry: "",
        message: "",
        consent: false,
      });
    } else {
      toast.error("Something went wrong. Try again!");
    }
  };

  return (
    <Box
      sx={{
        py: 10,
        px: 2,
        background: "linear-gradient(135deg, #f5f7ff, #e0e4ff)",
      }}
    >
      <Typography
        variant="h4"
        sx={{
          textAlign: "center",
          fontWeight: 900,
          mb: 8,
          color: "#1a237e",
          textShadow: "0px 0px 12px rgba(26,35,126,0.4)",
          fontSize: { xs: "1.6rem", sm: "2rem", md: "2.2rem" },
        }}
      >
        Quick Contact
      </Typography>

      <Box
        sx={{
          display: "flex",
          flexDirection: { xs: "column", md: "row" },
          gap: 4,
          alignItems: "stretch",
          justifyContent: "center",
        }}
      >
        {/* LEFT IMAGE */}
        <Box
          sx={{
            flex: 1,
            minWidth: 0,
            borderRadius: 4,
            overflow: "hidden",
            boxShadow: "0 8px 30px rgba(0,0,0,0.15)",
            display: "flex",
          }}
        >
          <img
            src={contactImage}
            alt="Contact"
            style={{
              width: "100%",
              height: "100%",
              objectFit: "cover",
              display: "block",
            }}
          />
        </Box>

        {/* RIGHT FORM */}
        <Box
          sx={{
            flex: 1,
            minWidth: 0,
            background: "rgba(255,255,255,0.85)",
            backdropFilter: "blur(6px)",
            borderRadius: 4,
            p: { xs: 3, md: 5 },
            boxShadow: "0 8px 30px rgba(0,0,0,0.1)",
            display: "flex",
            flexDirection: "column",
          }}
        >
          {responseMsg && (
            <Alert severity={responseMsg.type} sx={{ mb: 2, fontWeight: 600 }}>
              {responseMsg.text}
            </Alert>
          )}

          <Box
            component="form"
            onSubmit={handleSubmit}
            sx={{ gap: 2, display: "flex", flexDirection: "column" }}
          >
            <Box
              sx={{
                display: "flex",
                flexDirection: { xs: "column", sm: "row" },
                gap: 2,
              }}
            >
              <TextField
                fullWidth
                label="Full Name"
                name="name"
                value={formData.name}
                onChange={handleChange}
                required
              />
              <TextField
                fullWidth
                label="Email"
                name="email"
                type="email"
                value={formData.email}
                onChange={handleChange}
                required
              />
            </Box>

            <Box
              sx={{
                display: "flex",
                flexDirection: { xs: "column", sm: "row" },
                gap: 2,
              }}
            >
              <TextField
                fullWidth
                label="Phone Number"
                name="phone"
                value={formData.phone}
                onChange={handleChange}
              />
              <TextField
                fullWidth
                label="Company Name"
                name="company"
                value={formData.company}
                onChange={handleChange}
              />
            </Box>

            <TextField
              fullWidth
              label="Industry / Sector"
              name="industry"
              value={formData.industry}
              onChange={handleChange}
            />

            <TextField
              fullWidth
              label="Message / Inquiry"
              name="message"
              multiline
              rows={4}
              value={formData.message}
              onChange={handleChange}
            />

            <FormControlLabel
              control={
                <Checkbox
                  name="consent"
                  checked={formData.consent}
                  onChange={handleChange}
                />
              }
              label="I consent to having this website store my submitted information."
            />

            <Button
              type="submit"
              disabled={loading}
              sx={{
                px: 5,
                py: 1.5,
                background: "#1a237e",
                color: "#fff",
                fontWeight: 700,
                fontSize: "1rem",
                borderRadius: 3,
                boxShadow: "0 6px 20px rgba(26,35,126,0.4)",
                transition: "all 0.3s ease",
                "&:hover": {
                  background: "#162070",
                  transform: "translateY(-2px)",
                },
                mt: 2,
              }}
            >
              {loading ? "Sending..." : "Send Message"}
            </Button>
          </Box>
        </Box>
      </Box>
    </Box>
  );
}
